<href [link]="item().url">
    @if(item().image) {

    <div class="w-12 overflow-hidden"
         [ngClass]="EAdvertType.trending === type ? 'ratio-1-1' : 'ratio-3-4'">
        <shell />
        <img class="rf"
             [image]="image" />
    </div>
    }

    <div [ngClass]="EAdvertType.trending === type ? 'm-t-5' : 'center m-t-3'">
        @if (EAdvertType.default === type && item().name) {
        <p class="s1 m-t-2 underline">{{item().name}}</p>
        }
        @if (EAdvertType.trending === type) {
        @if(item().name) {
        <p class="s2">{{item().name}}</p>
        }
        @if (item().subtitle) {
        <p class="p2 m-t">{{item().subtitle}}</p>
        }
        }
    </div>
</href>